const Config = {
	API: 'https://tugtug.s3.amazonaws.com/comics',
	CACHE_BLOCKER: '20230407_2'
}
export default Config;